module.exports = __webpack_public_path__ + "static/img/2.3906540.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/website/2.jpeg
// module id = 6H7X
// module chunks = 1